/**
 * partsCatalogService.js
 *
 * The Dingli OEM spare-parts catalogue: which models are covered, a manual's
 * assemblies, one assembly's exploded drawing + parts table, and part search.
 * Read-only — the catalogue is reference data seeded from the parts manuals
 * (server/database/migrations/20260928_parts_catalog_*.sql).
 *
 * apiClient.get() takes a plain endpoint string and ignores an axios-style
 * { params } option, so query strings are built here.
 */
import apiClient from './apiClient';

const qs = (params) => {
    const sp = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') sp.append(k, v);
    });
    const s = sp.toString();
    return s ? `?${s}` : '';
};

const partsCatalogService = {
    /** Every model the catalogue covers, fleet models first. */
    getModels: () => apiClient.get('/parts-catalog/models'),

    /** One manual with its assemblies grouped by section (no part rows). */
    getManual: (key) => apiClient.get(`/parts-catalog/manuals/${encodeURIComponent(key)}`),

    /** One assembly: drawing(s) plus every part printed beside it. */
    getFigure: (key, code) => apiClient.get(
        `/parts-catalog/manuals/${encodeURIComponent(key)}/figures/${encodeURIComponent(code)}`,
    ),

    /** Find a part by number or description; `model` narrows it to one machine. */
    search: (params) => apiClient.get(`/parts-catalog/search${qs(params)}`),

    /** One part number and every assembly it is used on. */
    getPart: (partNumber) => apiClient.get(
        `/parts-catalog/parts/${encodeURIComponent(partNumber)}`,
    ),
};

export default partsCatalogService;
